const state = {
};

const getters = {
};

const actions = {
    LoadCronjobs({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('cronjobs.list_cronjobs', {
                domain_id: request_data['domain_id'],
            });
            this._vm.$axios.get(r)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    GetManageCronjob({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('cronjobs.manage_cronjob', {
                domain_id: request_data['domain_id'],
                cronjob_id: request_data['cronjob_id']
            });
            this._vm.$axios.get(r)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    SaveCronjob({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('cronjobs.save_cronjob', {
                domain_id: request_data['domain_id'],
                cronjob_id: request_data['cronjob_id']
            });
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    ActivateCronjob({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('cronjobs.activate_cronjob', {
                domain_id: request_data['domain_id'],
                cronjob_id: request_data['cronjob_id']
            });
            this._vm.$axios.get(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    DeactivateCronjob({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('cronjobs.deactivate_cronjob', {
                domain_id: request_data['domain_id'],
                cronjob_id: request_data['cronjob_id']
            });
            this._vm.$axios.get(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    DeactivateCheckedCronjobs({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('cronjobs.deactivate_cronjobs', {
                domain_id: request_data['domain_id'],
            });
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },
    ActivateCheckedCronjobs({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('cronjobs.activate_cronjobs', {
                domain_id: request_data['domain_id'],
            });
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    DeleteCronjob({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('cronjobs.delete_cronjob', {
                domain_id: request_data['domain_id'],
                cronjob_id: request_data['cronjob_id']
            });
            this._vm.$axios.get(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    DeleteCheckedCronjobs({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('cronjobs.delete_cronjobs', {
                domain_id: request_data['domain_id']
            });
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    GetCreateCronjob({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('cronjobs.get_create_cronjob', {
                domain_id: request_data['domain_id'],
            });
            this._vm.$axios.get(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    CreateCronJob({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('cronjobs.create_cronjob', {
                domain_id: request_data['domain_id'],
            });
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },
};

const mutations = {

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
